import React from 'react'
import ReactTooltip from 'react-tooltip'
import MessageUI from '../output/MessageUI'
import './IconButton.css'

const IconButtonUI = ({messageList, icon, customIcon, selected, onClick, labelKey, label, shortCutKey}) => (
  <div
    className={`w_icon_btn icon${icon ? ` ${icon}` : ''}${selected ? ' selected' : ''}`}
    onClick={onClick}
    data-tip
    data-for={`t-${icon || 'custom'}-${label ? label : '1'}`}
  >
    {customIcon ? (
      <span className="custom-icon">{customIcon}</span>
    ) : null}
    {!customIcon && icon && null /* icon is only a class, visual is handled by CSS */}
    {(label || labelKey) && (
      <ReactTooltip id={`t-${icon || 'custom'}-${label ? label : '1'}`}>
        <MessageUI messageList={messageList} messageKey={labelKey} label={label} />
        {shortCutKey && (
          <React.Fragment>
            <br/>[<MessageUI messageList={messageList} messageKey={shortCutKey} />]
          </React.Fragment>
        )}
      </ReactTooltip>
    )}
  </div>
);


export default IconButtonUI
